import { Grid, Box, TextField, Autocomplete } from "@mui/material";
import { FormikProps, getIn } from "formik";
import React from "react";
import { FieldOption } from "../FieldOption";
import { FormField } from "../FormField";
import { FixedLabel, maybePadRight } from "../Functions";

function MultipleAutocompleteField(props: {
  formik: FormikProps<Record<string, unknown>>;
  field: FormField;
  classes: Record<string, string>;
  variant: "filled" | "outlined" | "standard";
}) {
  const { formik, field, classes, variant } = props;

  const onChangeHandler = (
    _e: React.SyntheticEvent,
    newValue: (FieldOption | string)[] | null,
  ) => {
    formik.setFieldValue(field.id, newValue || []);
  };

  const getOptionLabel = (option: FieldOption | string) => {
    if (typeof option === "string") {
      return field.choices?.find((choice) => choice.id === option)?.text || "";
    } else return option.text;
  };

  const getOptionKey = (option: FieldOption) => {
    return option.id;
  };

  const isEqualChecker = (option: FieldOption, value: FieldOption | string) => {
    if (typeof value === "string") {
      return option.id === value;
    }
    return option.id === value.id;
  };

  return (
    <React.Fragment key={field.id}>
      <Grid size={{ xs: 12, sm: field.columns || 6 }} key={field.id}>
        {field.fixedLabel && <FixedLabel formik={formik} field={field} />}
        <Box sx={{ display: "flex" }}>
          <Box sx={{ flexGrow: 1 }}>
            <Autocomplete
              multiple
              groupBy={
                field.groupChoices
                  ? (option: FieldOption) => option.group
                  : undefined
              }
              value={getIn(formik.values, field.id) || null}
              onChange={onChangeHandler}
              getOptionLabel={getOptionLabel}
              getOptionKey={getOptionKey}
              isOptionEqualToValue={isEqualChecker}
              filterOptions={field.filterOptions}
              id={field.id}
              options={field.choices || []}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className={classes.formControl}
                  label={!field.fixedLabel && field.text}
                  variant={variant}
                  fullWidth
                  onBlur={formik.handleBlur}
                  helperText={
                    getIn(formik.touched, field.id) ? (
                      <>{getIn(formik.errors, field.id) as string}</>
                    ) : (
                      ""
                    )
                  }
                  error={
                    getIn(formik.touched, field.id) &&
                    Boolean(getIn(formik.errors, field.id))
                  }
                />
              )}
            />
          </Box>
        </Box>
      </Grid>
      {maybePadRight(field)}
    </React.Fragment>
  );
}

export default MultipleAutocompleteField;
